let setTokenExpiration = () => {
	const durationMinutes = 55,
				tokenDuration = durationMinutes * 60 * 1000,
				currentTime = new Date();
	return new Date(currentTime.getTime() + tokenDuration);
};

export default {
	setToken(ctx, payload) {
		ctx.commit("SET_TOKEN", payload);
		ctx.commit("SET_TOKEN_EXPIRATION", setTokenExpiration());
	},
	removeToken(ctx) {
		ctx.commit("REMOVE_TOKEN");
		ctx.commit("REMOVE_TOKEN_EXPIRATION");
	},
};
